import React from 'react';
import '../styles/Lots.css';
import LotsGrid from '../grids/LotsGrid';
import WhatsappCTA from '../components/WhatsappCTA';

const translations = {
  en: {
    title: "Available Lots in the Area",
    altText: "Map of available lots"
  },
  es: {
    title: "Lotes Disponibles en la Zona",
    altText: "Mapa de lotes disponibles"
  }
};

const Lots = ({ language }) => {
  return (
    <div className="lots-page">
      <h1>{translations[language].title}</h1>
      <LotsGrid language={language} /> 

      <WhatsappCTA language={language}/>
    </div>
  );
};

export default Lots;